'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ACCOUNT_BLOCKS_UPDATED = 'account-blocks:updated';
var ACCOUNT_BLOCKS_QUERY = 'account-blocks:query';
var ACCOUNT_REQUIRES_VERIFICATION_UPDATED = 'account-requires-verification:updated';
var ACCOUNT_REQUIRES_VERIFICATION_QUERY = 'account-requires-verification:query';
var ACCOUNT_BLOCK_STATUS_UPDATED = 'account-block-status:updated';
var ACCOUNT_BLOCK_STATUS_QUERY = 'account-block-status:query';
var ACCOUNT_PEP_BLOCK_UPDATED = 'account-pep-block:updated';
var ACCOUNT_PEP_BLOCK_QUERY = 'account-pep-block:query';
var ACCOUNT_PEP_DETAILS_UPDATED = 'account-pep-details:updated';
var ACCOUNT_PEP_DETAILS_QUERY = 'account-pep-details:query';
var ACCOUNT_USER_VERIFICATION_OVERRIDE = 'account-user-verification:overrided';
var ACCOUNT_IS_PROCESSING_STATUS_QUERY = 'account-is-processing-status:query';

exports.ACCOUNT_BLOCKS_QUERY = ACCOUNT_BLOCKS_QUERY;
exports.ACCOUNT_BLOCKS_UPDATED = ACCOUNT_BLOCKS_UPDATED;
exports.ACCOUNT_BLOCK_STATUS_QUERY = ACCOUNT_BLOCK_STATUS_QUERY;
exports.ACCOUNT_BLOCK_STATUS_UPDATED = ACCOUNT_BLOCK_STATUS_UPDATED;
exports.ACCOUNT_IS_PROCESSING_STATUS_QUERY = ACCOUNT_IS_PROCESSING_STATUS_QUERY;
exports.ACCOUNT_PEP_BLOCK_QUERY = ACCOUNT_PEP_BLOCK_QUERY;
exports.ACCOUNT_PEP_BLOCK_UPDATED = ACCOUNT_PEP_BLOCK_UPDATED;
exports.ACCOUNT_PEP_DETAILS_QUERY = ACCOUNT_PEP_DETAILS_QUERY;
exports.ACCOUNT_PEP_DETAILS_UPDATED = ACCOUNT_PEP_DETAILS_UPDATED;
exports.ACCOUNT_REQUIRES_VERIFICATION_QUERY = ACCOUNT_REQUIRES_VERIFICATION_QUERY;
exports.ACCOUNT_REQUIRES_VERIFICATION_UPDATED = ACCOUNT_REQUIRES_VERIFICATION_UPDATED;
exports.ACCOUNT_USER_VERIFICATION_OVERRIDE = ACCOUNT_USER_VERIFICATION_OVERRIDE;
